


















































































































// vue
import {
    defineComponent,
    onMounted,
    computed,
    watch,
    ref,
} from '@vue/composition-api';

// hooks
import { useStore } from '@/store';
import logo from '@/assets/clere-logo.png';

// components
import AppBar from '@/vue3/components/AppBar.vue';
import Footer from '@/vue3/components/Footer.vue';
import NavigationDrawer from '@/vue3/components/NavigationDrawer.vue';

export default defineComponent({
    components: {
        AppBar,
        Footer,
        NavigationDrawer,
    },
    setup(props: any, vm) {
        // hooks
        const store = useStore();

        // properties
        const mobileWidth = 1024;

        // reactive
        const isUtilityOpen = ref(false);

        // computed
        const currentTheme = computed(() => {
            return () => import('./vue3/components/themes/VelaBlue.vue');
        });

        // methods
        const setIsUtilityOpen = (value: boolean) => {
            isUtilityOpen.value = value;
        };

        // watch
        watch(
            () => vm.root.$route.name,
            (state: any) => {
                store.commit(
                    'setIsFullScreen',
                    store.state.fullScreenRoutes.indexOf(state) !== -1,
                );
            },
        );

        // lifecycle
        onMounted(() => {
            if (window.innerWidth >= mobileWidth) {
                store.state.isMobile = false;
            } else {
                store.state.isMobile = true;
            }

            window.addEventListener('resize', () => {
                if (window.innerWidth >= mobileWidth) {
                    store.state.isMobile = false;
                } else {
                    store.state.isMobile = true;
                }
            });
        });

        return {
            logo,
            store,
            isUtilityOpen,
            setIsUtilityOpen,
            currentTheme,
        };
    },
});
